<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1">IMAGES OF WAR</h1>
<p class="stitle2"><span class="bold">GERMAN ARMOUR LOST</span></p>
<p class="stitle2"><span class="bold">ON THE WESTERN FRONT</span></p>
<p class="stitle3">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</p>
<p class="author"><span class="bold">BOB CARRUTHERS</span></p>
<div class="img_container5">
<p class="pub"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?677ef5e3